var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.onClickAppleButton}},[_c('img',{staticClass:"max-w-312px h-auto w-full hover:cursor-pointer",attrs:{"src":_vm.loginApple,"alt":"Sign up with Apple"}})])}
var staticRenderFns = []

export { render, staticRenderFns }